const END_POINT = {
    LOGIN: `${process.env.REACT_APP_API_URL}/auth/login`,
    LOGOUT: `${process.env.REACT_APP_API_URL}/logout`,
    CUSTOMERS: `${process.env.REACT_APP_API_URL}/getUsers`,
    CUSTOMERS_L: `/admin/data/customer/items.json`,
    CUSTOMER: `${process.env.REACT_APP_API_URL}/getUserDetails`,
    CUSTOMER_UPDATE: `${process.env.REACT_APP_API_URL}/updateUser`,
    CUSTOMER_NUMBER: `${process.env.REACT_APP_API_URL}/getNumberUsedByUser`,
    CUSTOMER_ADD_CREDIT: `${process.env.REACT_APP_API_URL}/number/addMinutes`,
    CUSTOMER_REMOVE_CREDIT: `${process.env.REACT_APP_API_URL}/number/removeMinutes`,
    CUSTOMER_VERIFY: `${process.env.REACT_APP_API_URL}/auth/verifyUser`,
    CREATE_CUSTOMER: `${process.env.REACT_APP_API_URL}/auth/signup`,
    RESETPWD: `${process.env.REACT_APP_API_URL}/resetPassword`,
    FORGOTPWD: `${process.env.REACT_APP_API_URL}/auth/v1/forgotPassword`,
    NEWPWD: `${process.env.REACT_APP_API_URL}/auth/resetPasswordWithToken`,
    // GET_CREDIT_LOGS: `${process.env.REACT_APP_API_URL}/creditLogs/getCreditLogsByNumber`,
    GET_CREDIT_LOGS: `${process.env.REACT_APP_API_URL}/creditLogs/getCreditLogsByFilter`,
    CUSTOMER_NUMBER_OWNED: `${process.env.REACT_APP_API_URL}/getNumberOwnedByUser`,
    CUSTOMER_BUSINESS_NUMBER_OWNED: `${process.env.REACT_APP_API_URL}/getBusinessNumbersOwnedByUser`,
    GENERATE_CREDIT_REPORT: `${process.env.REACT_APP_API_URL}/generate/credit-report`,
    GENERATE_CREDIT_REPORT_CSV: `${process.env.REACT_APP_API_URL}/generate/credit-report/csv`,
    GET_NUMBERS_OWNED_BY_TYPE_PERSON: `${process.env.REACT_APP_API_URL}/getNumbersOwnedByTypePerson`,
    GET_NUMBERS_OWNED_BY_TYPE_BUSINESS: `${process.env.REACT_APP_API_URL}/getNumbersOwnedByTypeBusiness`,

    CUSTOMER_NUMBER_EXT_PLAN_USED: `${process.env.REACT_APP_API_URL}/getNonBusinessExtAndCreditPlanNumbersUsedByUser`,
    CUSTOMER_NUMBER_GROUP_USED: `${process.env.REACT_APP_API_URL}/getNonBusinessCreditGroupNumbersUsedByUser`,
    CUSTOMER_BUSINESS_NUMBER_EXT_PLAN_OWNED: `${process.env.REACT_APP_API_URL}/getExtAndCreditPlanBusinessNumbersOwnedByUser`,
    CUSTOMER_BUSINESS_NUMBER_GROUP_OWNED: `${process.env.REACT_APP_API_URL}/getCreditGroupBusinessNumbersOwnedByUser`,
    CUSTOMER_CREATE_RATING: `${process.env.REACT_APP_API_URL}/createRating`,

    GET_VIDEOMAILS: `${process.env.REACT_APP_API_URL}/getVideoEmails`,
    DELETE_VIDEOMAIL: `${process.env.REACT_APP_API_URL}/deleteVideoEmail`,
    SEARCH_BUSINESS: `${process.env.REACT_APP_API_URL}/web/searchBusiness`,
    SERVICE_DIRECTORY_SEARCH_BUSINESS: `${process.env.REACT_APP_API_URL}/searchBusiness`,
    GET_ALL_BUSINESS: `${process.env.REACT_APP_API_URL}/getAllBusiness`,
    GET_ALL_BUSINESS_DISPLAY_UNIT_LIST: `${process.env.REACT_APP_API_URL}/getBusinessGroupedByDisplayGroup`,
    GET_BUSINESS_BY_ID: `${process.env.REACT_APP_API_URL}/getBusinessById`,
    GET_BUSINESS_DISPLAY_UNIT: `${process.env.REACT_APP_API_URL}/getBusinessByDisplayGroupId`,
    SEARCH_BUSINESS_WITH_BUSINESSGROUP: `${process.env.REACT_APP_API_URL}/searchBusinessWithBusinessGroupForDisplay`,
    GET_CALL_HISTORY: `${process.env.REACT_APP_API_URL}/creditLogs/getCallHistory`,
    GET_CUSTOMER_FEATURES: `${process.env.REACT_APP_API_URL}/getUserFeatures`,
    GET_CUSTOMER_NUMBER: `${process.env.REACT_APP_API_URL}/getNumberUsedByUser`,
    // Participants
    GET_PARTICIPANT_TYPE: `${process.env.REACT_APP_API_URL}/getParticipantType`,
    // Voice Conference
    MUTE_USER_VOICE_CONFERENCE: `${process.env.REACT_APP_API_URL}/HOHUserMuteDone`,
    UNMUTE_USER_VOICE_CONFERENCE: `${process.env.REACT_APP_API_URL}/HOHUserUnMuteDone`,

    // get usage report
    Get_BILLING_CODE_BY_EMAIL: `${process.env.REACT_APP_API_URL}/getBillingCodesByEmail`,
    BUSINESS_USAGE_REPORT: `${process.env.REACT_APP_API_URL}/businessUsageReport`,
    GENERATE_USAGE_REPORT_PDF: `${process.env.REACT_APP_API_URL}/generate/usageReport/pdf`,
    GENERATE_USAGE_REPORT_CVS: `${process.env.REACT_APP_API_URL}/generate/usageReport/csv`,

    // send video mail
    SEND_VIDEO_MAIL: `${process.env.REACT_APP_API_URL}/sendVideoEmail`,

    // account deletion
    ACCOUNT_DELETION: `${process.env.REACT_APP_API_URL}/requestForDeleteAccount`,
    // v1
    LOGIN_V1: `${process.env.REACT_APP_API_URL}/auth/v1/login`,

    FEATURE_FLAG: `${process.env.REACT_APP_API_URL}/featureFlag/flagStatus`,

    MAKE_CALL: `${process.env.REACT_APP_API_URL}/makeCall`,
    JOIN_ROOM: `${process.env.REACT_APP_API_URL}/joinRoom`,
    GET_REQUEST_BY_ID: `${process.env.REACT_APP_API_URL}/getRequestById`,
    END_VIDEO_ROOM: `${process.env.REACT_APP_API_URL}/endVideoRoom`,
    USER_DEVICE_REGISTER: `${process.env.REACT_APP_API_URL}/userDeviceRegister`,
    GET_USER_DEVICES: `${process.env.REACT_APP_API_URL}/getUserDevices`,
    CREATE_SWITCH_DEVICE_REQUEST: `${process.env.REACT_APP_API_URL}/createSwitchDeviceRequest`,
    CANCEL_SWITCH_DEVICE_REQUEST: `${process.env.REACT_APP_API_URL}/cancelSwitchDeviceRequest`,
    GET_SWITCH_DEVICE_CHAT_KEY: `${process.env.REACT_APP_API_URL}/getSwitchDeviceChatKey`,
    SEND_SWITCH_DEVICE_CHAT_HISTORY: `${process.env.REACT_APP_API_URL}/sendSwitchDeviceChatHistory`,
    REJECT_CALL: `${process.env.REACT_APP_API_URL}/rejectCall`,
    HEALTH_CHECK: `${process.env.REACT_APP_API_URL}/actuator/health`,
    PARSE_EXTERNAL_MEETING_URL: `${process.env.REACT_APP_API_URL}/parseExternalMeetingUrl`,
};

export default END_POINT;
